import { render } from "./TodoCardEndPagamento.vue?vue&type=template&id=bcde811c"
import script from "./TodoCardEndPagamento.vue?vue&type=script&lang=js"
export * from "./TodoCardEndPagamento.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__